import { createContext, useContext } from "react";

export const CallsContext = createContext(null);
export const useCalls = () => useContext(CallsContext);
